/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-shadow */
import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Collapse,
  Box,
  InputAdornment,
  Button,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useAuth } from "react-oidc-context";
import styles from "../QuoteMultipleDestinationsPanel.module.css";
import { icons } from "../../../svg";
import PinIcon from "../../../svg/pin.svg?react";
import { XIcon } from "../../../icons";
import { QuotedRateIcon } from "../../../icons/QuotedRateIcon";
import { QuotedRateNotifiedIcon } from "../../../icons/QuotedRateNotifiedIcon";
import PinWithSlashIcon from "../../../svg/pinWithSlash.svg?react";
import { OriginTableOld } from "./OriginTableOld";
import { useNitroStore } from "../../../store/Store";
import {
  FreightTruck,
  IQuotesByDestinationOld,
  ISurroundingLocationsParams,
} from "../../../types/ICompAnalysisQMD";
import { useNitroCAStore } from "../../../store/CompetitiveAnalysisStore";
import TruckIconFO from "../../../icons/TruckIconFO";
import RailIconFO from "../../../icons/RailIconFO";
import { NitroMarkerBase } from "../../../components/map/components/NitroMarker";
import { toCamelCase } from "../../../utils/String";
import { SurroundingLocationsTableOld } from "./SurroundingLocationsTableOld";
import { MissingProductTable } from "../components/MissingProductTable";
import {
  getQuoteRowKey,
  isRailFreightQuotedOrNotified,
  normalizeDestinationName,
  sortDestinations,
} from "../components/multiLocationQuoteUtils";
import { useQuotesForSurroundingLocations } from "../../../hooks/useQuotesForSurroundingLocations";
import { IFavoriteOrigin } from "../../../types/IFavoriteOrigins";
import { convertQuotesToRoutesOld } from "../../../utils/convertQuotesToRoutes";
import { useQuotesForSurroundingLocationsOld } from "../../../hooks/useQuotesForSurroundingLocationsOld";

// TODO: fob netback color box is weird size for some values
// TODO: filtering text box while destination is open causes map pin to disappear
// TODO: removing product and other logistics updates does not update quotes in this panel
// TODO: Garden city
// TODO: check expansion logic

export const QuoteMultipleDestinationsPanelOld: React.FC<{
  destinationQuotes: IQuotesByDestinationOld[];
  favoriteOrigins: IFavoriteOrigin[];
}> = ({ destinationQuotes, favoriteOrigins }) => {
  const [
    setSelectedLocation,
    setTempPinLocation,
    multiLocationDestinations,
    product,
    currentFilters,
    openInsightsPanel,
    currency,
    uom,
    refetchTrigger,
    setMultiLocationDestinations,
    setShowHidePinsPopup,
    setPanToCoordinates,
  ] = useNitroStore((state) => [
    state.setSelectedLocation,
    state.setTempPinLocation,
    state.multiLocationDestinations,
    state.product,
    state.currentFilters,
    state.openInsightsPanel,
    state.currency,
    state.uom,
    state.refetchSurroundingLocations,
    state.setMultiLocationDestinations,
    state.setShowHidePinsPopup,
    state.setPanToCoordinates,
  ]);
  const refetchMultiLocation = useNitroCAStore(
    (state) => state.refetchMultiLocation,
  );
  const [
    setDisplayFreightDetailsPanel,
    triggerReset,
    expandedDestination,
    hiddenOrigins,
    setRailFreightDetailContext,
    setSelectedTruckDetailRecord,
    setDisplayTruckFreightDetailsPanel,
    setAnchorForTruckDetailsPanel,
    setDisplayInboundModeTogglePanel,
    resetExpandRailOriginsWithNoFreight,
    setExpandRailOriginsWithNoFreightTrigger,
    resetExpandTruckOriginsWithNoFreight,
    setExpandTruckOriginsWithNoFreightTrigger,
    setExpandedDestination,
    surroundingQuoteOpen,
    triggerCloseSurroundingQuote,
    setDestinationQuoteOpen,
    closeDestinationQuote,
    expandedDestId,
    setExpandedDestId,
    railTeamNotifiedRows,
  ] = useNitroCAStore((state) => [
    state.setDisplayRailFreightDetailsPanel,
    state.triggerReset,
    state.expandedDestination,
    state.hiddenOrigins,
    state.setRailFreightDetailContext,
    state.setSelectedTruckDetailRecord,
    state.setDisplayTruckFreightDetailsPanel,
    state.setAnchorForTruckDetailsPanel,
    state.setDisplayInboundModeTogglePanel,
    state.resetExpandRailOriginsWithNoFreight,
    state.setExpandRailOriginsWithNoFreightTrigger,
    state.resetExpandTruckOriginsWithNoFreight,
    state.setExpandTruckOriginsWithNoFreightTrigger,
    state.setExpandedDestination,
    state.surroundingQuoteOpen,
    state.triggerCloseSurroundingQuote,
    state.setDestinationQuoteOpen,
    state.closeDestinationQuote,
    state.expandedDestId,
    state.setExpandedDestId,
    state.railTeamNotifiedRows,
  ]);
  const auth = useAuth();
  const user = `${auth.user?.profile.given_name} ${auth.user?.profile.family_name}`;
  const [filterText, setFilterText] = useState("");
  const [showSurroundingLocations, setShowSurroundingLocations] =
    useState(false);
  const [showDestinationsWithoutProduct, setShowDestinationsWithoutProduct] =
    useState(false);
  const [hoveringDestination, setHoveringDestination] = useState({
    isHovering: false,
    id: "",
  });

  // hide the destination header when the user has scrolled into an open origin table
  const [hideDestHeader, setHideDestHeader] = useState(false);
  useEffect(() => {
    const scrollContainer = document.getElementById(
      "deskstop-destination-table",
    );
    if (!scrollContainer) return;
    const handleScroll = () => {
      if (!expandedDestId) {
        setHideDestHeader(false);
        return;
      }
      const originTable = scrollContainer.querySelector(
        "[data-origin-table-root]",
      );
      if (!originTable) {
        setHideDestHeader(false);
        return;
      }
      const containerTop = scrollContainer.getBoundingClientRect().top;
      const { top: originTop, bottom: originBottom } =
        originTable.getBoundingClientRect();
      const shouldHide =
        originTop <= containerTop + 36 && originBottom > containerTop;
      setHideDestHeader(shouldHide);
    };
    // check immediately when a row expands/collapses
    handleScroll();
    scrollContainer.addEventListener("scroll", handleScroll);
    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, [expandedDestId]);
  const queryType =
    currentFilters.city || currentFilters.location ? "location" : "party";

  const getDisplayTitle = () => {
    const whoValue = currentFilters.party;
    let whereValue = currentFilters.city || currentFilters.location;
    if (currentFilters.city) {
      const cityState = currentFilters.city.split(",");
      const city = toCamelCase(cityState[0]);
      const state = cityState[1]?.trim();
      whereValue = `${city}, ${state}`;
    }
    if (whereValue && whoValue) {
      return `${whoValue} - ${whereValue}`;
    }
    if (whereValue) {
      return whereValue;
    }
    if (whoValue) {
      return whoValue;
    }
    return "";
  };
  const applyTextFilter = (entry: IQuotesByDestinationOld) =>
    entry.destination.displayName
      .toLowerCase()
      .includes(filterText.toLowerCase()) ||
    entry.destination.city?.toLowerCase().includes(filterText.toLowerCase()) ||
    entry.destination.stateOrProvince
      ?.toLowerCase()
      .includes(filterText.toLowerCase());

  // load surrounding quotes when panel loads
  const locationParams: ISurroundingLocationsParams = {
    party_id: currentFilters.party,
    citystate_id: currentFilters.city,
    product,
    marketer: user,
    shipDate: currentFilters.month || "",
    currency: currency || "USD",
    uom: uom || "ST",
  };
  // TODO: handle error
  // TODO: can this be combined with primary quotes hook to reduce calls?
  // TODO: add loading for inbound rail adding rail stations

  // only fetches for city filters
  const {
    surroundingQuotes,
    loading: isLoadingSurroundingQuotes,
    error: surroundingQuotesError,
  } = useQuotesForSurroundingLocationsOld(locationParams, refetchTrigger);
  // add surrounding quotes to map
  useEffect(() => {
    if (surroundingQuotes.length > 0) {
      // if the expand surrounding locations flag is on then show surrounding locations table and pins on the map
      if (expandedDestination?.expandSurroundingLocations) {
        // slight delay to allow panel to render first to avoid jumpy UI
        setTimeout(() => {
          setShowSurroundingLocations(true);
        }, 100);
        const quotes = [...destinationQuotes, ...surroundingQuotes];
        const multiLocDataCompAnalysis = convertQuotesToRoutesOld(quotes);
        setMultiLocationDestinations(multiLocDataCompAnalysis);
      }
    }
  }, [destinationQuotes, surroundingQuotes, setMultiLocationDestinations]);

  // TODO: Locations without product up collapse is glitchy with info
  const { filteredDestinationQuotes, destinationsWithoutProduct } =
    useMemo(() => {
      // TODO: make api not return quotes for hidden modes and is this favorite origin mode selection or enabled mode?
      // TODO: need to read location outbound? or update favorite toggles when location mode changes
      // applying mode filters
      const filteredByModes = destinationQuotes.map((entry) => {
        const filteredQuotes = entry.quotes.filter((quote) => {
          const mode = quote.mode.toLowerCase();
          const originKey = `${quote.competitor ? "competitor" : "koch"}-${
            quote.origin?.name
          }`;
          return !hiddenOrigins[mode as "truck" | "rail"].has(originKey);
        });
        return {
          destination: entry.destination,
          quotes: filteredQuotes,
        };
      });

      // applying product filter
      // include city pin records even if they don't have the product (city records don't have that kind of data)
      const filteredByProduct = filteredByModes.filter(
        (entry) =>
          entry.destination.availableProducts.includes(product) ||
          entry.destination.isCity,
      );

      // destinations without product with city pins excluded
      const destWithoutProduct = filteredByModes.filter(
        (entry) =>
          !entry.destination.availableProducts.includes(product) &&
          !entry.destination.isCity,
      );

      // no text filter applied
      if (!filterText) {
        return {
          filteredDestinationQuotes: sortDestinations(
            filteredByProduct,
            queryType,
          ) as IQuotesByDestinationOld[],
          destinationsWithoutProduct: destWithoutProduct,
        };
      }

      const filteredDestinations = sortDestinations(
        filteredByProduct.filter(applyTextFilter),
        queryType,
      ) as IQuotesByDestinationOld[];
      const destinationsWithoutProduct =
        destWithoutProduct.filter(applyTextFilter);

      // applying text filter
      return {
        filteredDestinationQuotes: filteredDestinations,
        destinationsWithoutProduct,
      };
    }, [destinationQuotes, filterText, hiddenOrigins, product]);

  // close panel effect
  useEffect(() => {
    setExpandedDestId(undefined);
    setDestinationQuoteOpen(false);
  }, [closeDestinationQuote]);

  // text filter effect
  // TODO: i think that the dropdowns will close when i remove filter. is that supposed to happen?
  useEffect(() => {
    if (filterText && destinationsWithoutProduct.length > 0) {
      setShowDestinationsWithoutProduct(true);
    } else {
      setShowDestinationsWithoutProduct(false);
    }
    if (filterText && surroundingQuotes.length > 0) {
      setShowSurroundingLocations(true);
    } else {
      setShowSurroundingLocations(false);
    }
  }, [destinationsWithoutProduct, filterText, surroundingQuotes]);

  useEffect(() => {
    let quotesToShowOnMap = [
      ...filteredDestinationQuotes,
      ...destinationsWithoutProduct,
    ];
    quotesToShowOnMap =
      surroundingQuotes.length > 0 && showSurroundingLocations
        ? [...quotesToShowOnMap, ...surroundingQuotes.filter(applyTextFilter)]
        : quotesToShowOnMap;
    // reset map pins to only show filtered results
    setMultiLocationDestinations(convertQuotesToRoutesOld(quotesToShowOnMap));
  }, [showSurroundingLocations, filterText]);

  // generic function that handles behavior for expanding/collapsing destination rows whether from button click or external trigger
  const handleToggleExpand = (dest: { id: string; name: string }) => {
    // always perform these actions
    setDisplayInboundModeTogglePanel(false);
    setDisplayFreightDetailsPanel(false);
    const isCurrentlyExpanded = expandedDestId === dest.id;
    setExpandedDestId(isCurrentlyExpanded ? undefined : dest.id);

    // only perform these actions when collapsing
    if (isCurrentlyExpanded) {
      setSelectedLocation(undefined);
      setTempPinLocation(undefined);
      setDestinationQuoteOpen(false);
      setShowHidePinsPopup(true);
      return;
    }

    // only perform these actions when expanding
    const destinationRecord = multiLocationDestinations?.find(
      (record: any) =>
        record.destination?.id === dest.id ||
        record.destination?.name === dest.name,
    );

    if (destinationRecord?.destination) {
      const locationRecord = {
        id: destinationRecord.destination.id,
        name: destinationRecord.destination.name,
        owner: destinationRecord.destination.owner || "",
        address: "",
        city: destinationRecord.destination.city || "",
        state: "",
        zip: "",
        country: "",
        price: null,
        lat: destinationRecord.destination.coordinate?.[0] || 0,
        long: destinationRecord.destination.coordinate?.[1] || 0,
        products: [],
        modes: [],
        carriers: [],
        pinType: "customer" as const,
      };

      // when expanding a destination row we want to close surrounding quotes panel if open
      if (surroundingQuoteOpen) {
        triggerCloseSurroundingQuote();
      }
      setShowHidePinsPopup(false);
      setDestinationQuoteOpen(true);
      setSelectedLocation(locationRecord);
      setPanToCoordinates({
        lat: locationRecord.lat,
        lng: locationRecord.long,
        zoom: 0,
      });
      triggerReset();
    }
  };

  // specific function for handling button click to expand/collapse destination rows
  const handleToggleClick = (dest: { id: string; name: string }) => {
    // when user clicks the button we want to reset any expansions set to display
    resetExpandTruckOriginsWithNoFreight();
    resetExpandRailOriginsWithNoFreight();
    const isCurrentlyExpanded = expandedDestId === dest.id;
    if (isCurrentlyExpanded) {
      setExpandedDestination(undefined);
    }
    handleToggleExpand(dest);
  };

  // specific effect for handling external trigger to expand/collapse destination rows
  // currently only use cases are opening truck or rail with no freight separately
  useEffect(() => {
    if (expandedDestination) {
      // opening surrounding locations is handled in separate effect below
      if (expandedDestination.expandSurroundingLocations) {
        return;
      }
      // if the expand rail with no freight flag is on then use generic function without special handling for actual button click
      if (expandedDestination.expandRailWithNoFreight) {
        setExpandRailOriginsWithNoFreightTrigger();
      }
      // if the expand truck with no freight flag is on then use generic function without special handling for actual button click
      if (expandedDestination.expandTruckWithNoFreight) {
        setExpandTruckOriginsWithNoFreightTrigger();
      }
      handleToggleExpand(expandedDestination);
    }
  }, [expandedDestination]);

  // TODO: make header titles stick during scrolling
  // TODO: make surrounding locations table not reach the bottom
  // TODO: find cheapest origin for destination and show that in header
  // TODO: make filter conditional and put bottom line there if not showing up
  // TODO: state and display name should appear
  // TODO: origin panel search color does not change at the same time
  // TODO: type in origin price and quote panel does not update
  // TODO: closing insights panel reloads quotes for some reason
  return (
    <Paper id="panelWrapper" className={styles.panelWrapper} elevation={0}>
      <div id="destinationTitle" className={styles.destinationTitleContainer}>
        <span style={{ display: "flex", alignItems: "end", gap: 8 }}>
          <img
            src={icons.CityIcon}
            alt="Building Black Icon"
            height={31}
            width={31}
          />
          <span className={styles.destinationTitle}>{getDisplayTitle()}</span>
        </span>
        {/* Filter Box */}
        {(currentFilters.city || currentFilters.party) && (
          <Box className={styles.filterBox}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Filter Locations..."
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              className={styles.filterInput}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  background: "#F8FAFC",
                  paddingRight: 1,
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #E2E8F0",
                },
                "& .MuiOutlinedInput-input": {
                  display: "flex",
                  alignItems: "center",
                  padding: "5px 8px 6px 0px",
                },
                "& .MuiOutlinedInput-input::placeholder": {
                  opacity: 1,
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      src={icons.SearchMagnifyingGlass}
                      alt="Search Magnifying Glass Icon"
                    />
                  </InputAdornment>
                ),
                endAdornment: filterText ? (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setFilterText("")}>
                      <XIcon size={18} />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
            />
          </Box>
        )}
      </div>

      {/* Tables */}
      <div
        id="deskstop-destination-table"
        style={{
          flexGrow: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {/* Destinations Table */}
        {filteredDestinationQuotes.length > 0 && ( // HERE
          <TableContainer
            className={styles.tableContainerWrapper}
            style={{ overflow: "visible" }}
          >
            <Table stickyHeader>
              {" "}
              {/* HERE */}
              <TableHead
                className={`${styles.destinationTableHead}${
                  hideDestHeader ? ` ${styles.destinationTableHeadHidden}` : ""
                }`}
              >
                <TableRow>
                  <TableCell className={styles.headerCell}>
                    Destination
                  </TableCell>
                  <TableCell className={styles.headerCell}>
                    Competitor
                    <br />
                    <span style={{ whiteSpace: "nowrap" }}>DLVD Offer</span>
                  </TableCell>
                  <TableCell className={styles.headerCell}>
                    Koch
                    <br />
                    <span style={{ whiteSpace: "nowrap" }}>DLVD Offer</span>
                  </TableCell>
                  <TableCell
                    className={styles.headerCell}
                    style={{ paddingLeft: "7px" }}
                  >
                    Freight
                  </TableCell>
                  <TableCell className={styles.headerCell}>
                    FOB Netback
                  </TableCell>
                  <TableCell className={styles.headerCell}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody id="destination-table-body">
                {filteredDestinationQuotes.map((entry) => {
                  const isExpanded = expandedDestId === entry.destination.id;
                  const isHovering =
                    hoveringDestination.isHovering &&
                    hoveringDestination.id === entry.destination.id;
                  const isDestinationNameTruncated =
                    entry.destination.displayName.length > 15;
                  const destinationName = isDestinationNameTruncated
                    ? `${entry.destination.displayName.slice(0, 15)}...`
                    : entry.destination.displayName;
                  const cityState = `${toCamelCase(
                    entry.destination.city || "",
                  )}, ${entry.destination.stateOrProvince || ""}`;

                  // Find the cheapest koch and competitor quote for this destination
                  const cheapestKochQuote = entry.quotes.find(
                    (quote) => !quote.competitor && !quote.freight?.isExternal,
                  );
                  const cheapestCompetitorQuote = entry.quotes.find(
                    (quote) => quote.competitor,
                  );
                  const hasTruckInbound =
                    entry.destination.isCity ||
                    entry.destination.details?.inboundModes.includes("TRUCK");
                  const hasRailInbound =
                    entry.destination.details?.inboundModes.includes("RAIL");

                  // Determine display values
                  const determineDisplayValues = () => {
                    // if the user has not selected a koch origin as a favorite then display dashes for the table header
                    if (
                      !cheapestKochQuote ||
                      (!hasTruckInbound && !hasRailInbound)
                    ) {
                      return {
                        deliveredPrice: "--",
                        freight: "--",
                        netback: 0,
                        alternative: 0,
                        isKochPriceSetter: true,
                      };
                    }
                    const { freight, initialOffer, maxPrice, minPrice } =
                      cheapestKochQuote;
                    const kochDeliveredValue = cheapestKochQuote?.initialOffer
                      ? Number(cheapestKochQuote.initialOffer)
                      : 0;
                    const competitorDeliveredValue =
                      cheapestCompetitorQuote?.initialOffer
                        ? Number(cheapestCompetitorQuote.initialOffer)
                        : 0;

                    return {
                      // if there is no freight data, display dashes for dlvd price and freight
                      // if the user has not typed in a FOB price then display dashes for dlvd price
                      // if mode is rail we have to check if the freight is valid. truck is always shown as valid
                      deliveredPrice: initialOffer || "--",
                      freight: freight ? freight.totalFreight.toFixed(2) : "--",
                      netback: maxPrice?.toFixed(0) || 0,
                      alternative: minPrice?.toFixed(0) || 0,
                      isKochPriceSetter:
                        kochDeliveredValue <= competitorDeliveredValue,
                    };
                  };
                  const {
                    deliveredPrice,
                    freight,
                    netback,
                    alternative,
                    isKochPriceSetter,
                  } = determineDisplayValues();

                  const { isQuoted, isNotified } =
                    isRailFreightQuotedOrNotified(
                      railTeamNotifiedRows,
                      cheapestKochQuote,
                    );

                  let freightColor = "#475569";
                  if (isNotified) freightColor = "#009F5C";
                  else if (isQuoted) freightColor = "#155DFC";

                  let freightHoverColor = "#2563EB";
                  if (isNotified) freightHoverColor = "#007A47";
                  else if (isQuoted) freightHoverColor = "#1246C2";

                  const freightBg = "transparent";
                  const freightHoverBg = "#E8EFF7";

                  const destinationTooltipSlotProps = {
                    tooltip: {
                      sx: {
                        background: "#ddeefc",
                        color: "#1e3a8a",
                        fontSize: "14px",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#ddeefc",
                      },
                    },
                  };
                  return (
                    <React.Fragment key={entry.destination.id}>
                      <TableRow className={styles.destinationRow}>
                        {/* Destination Cell - if city pin then this cell is not a button since there is no location overview */}
                        <TableCell>
                          {entry.destination.isCity ? (
                            <>
                              {isDestinationNameTruncated ? (
                                <Tooltip
                                  title={normalizeDestinationName(
                                    entry.destination.displayName,
                                  )}
                                  arrow
                                  slotProps={destinationTooltipSlotProps}
                                >
                                  <div
                                    style={{ paddingTop: "10px" }}
                                    className={styles.destinationName}
                                  >
                                    {destinationName}
                                  </div>
                                </Tooltip>
                              ) : (
                                <div
                                  style={{ paddingTop: "10px" }}
                                  className={styles.destinationName}
                                >
                                  {destinationName}
                                </div>
                              )}

                              <Box className={styles.locationCell}>
                                <NitroMarkerBase
                                  width={20}
                                  height={25}
                                  type={entry.destination.pinType || ""}
                                />
                                <span
                                  className={`${styles.destinationLocation} ${
                                    cityState.length > 17
                                      ? styles.longCityStateFontSize
                                      : styles.shortCityStateFontSize
                                  }`}
                                >
                                  {cityState}
                                </span>
                              </Box>
                            </>
                          ) : (
                            <Button
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                paddingTop: "10px",
                                paddingLeft: "0px",
                                paddingRight: "0px",
                                paddingBottom: "0px",
                                "&:hover": { backgroundColor: "transparent" },
                              }}
                              onMouseEnter={() =>
                                setHoveringDestination({
                                  isHovering: true,
                                  id: entry.destination.id,
                                })
                              }
                              onMouseLeave={() =>
                                setHoveringDestination({
                                  isHovering: false,
                                  id: "",
                                })
                              }
                              onClick={() =>
                                openInsightsPanel(
                                  entry.destination.id,
                                  "Logistics",
                                  false,
                                )
                              }
                            >
                              {isDestinationNameTruncated ? (
                                <Tooltip
                                  title={normalizeDestinationName(
                                    entry.destination.displayName,
                                  )}
                                  arrow
                                  slotProps={destinationTooltipSlotProps}
                                >
                                  <div
                                    className={
                                      isHovering
                                        ? styles.destinationNameHover
                                        : styles.destinationName
                                    }
                                  >
                                    {normalizeDestinationName(destinationName)}
                                  </div>
                                </Tooltip>
                              ) : (
                                <div
                                  className={
                                    isHovering
                                      ? styles.destinationNameHover
                                      : styles.destinationName
                                  }
                                >
                                  {normalizeDestinationName(destinationName)}
                                </div>
                              )}

                              <Box className={styles.locationCell}>
                                <NitroMarkerBase
                                  width={20}
                                  height={25}
                                  type={entry.destination.pinType || ""}
                                />
                                <span
                                  className={`${styles.destinationLocation} ${
                                    cityState.length > 17
                                      ? styles.longCityStateFontSize
                                      : styles.shortCityStateFontSize
                                  }`}
                                >
                                  {toCamelCase(entry.destination.city || "")},{" "}
                                  {entry.destination.stateOrProvince}
                                </span>
                              </Box>
                            </Button>
                          )}
                        </TableCell>
                        {/* Competitor DLVD Offer Cell */}
                        <TableCell>
                          <span
                            className={`${styles.destinationFOBNetback} ${
                              !isKochPriceSetter
                                ? styles.dlvdPriceSetterText
                                : ""
                            }`}
                          >
                            ${cheapestCompetitorQuote?.initialOffer || "--"}
                          </span>
                          {cheapestCompetitorQuote?.initialOffer && (
                            <Box className={styles.dlvdOfferSubCell}>
                              {cheapestCompetitorQuote.mode.toUpperCase() ===
                                "TRUCK" && (
                                <TruckIconFO color="#60A5FA" paddingTop={4} />
                              )}
                              {cheapestCompetitorQuote.mode.toUpperCase() ===
                                "RAIL" && (
                                <RailIconFO color="#F97316" paddingTop={4} />
                              )}
                              <span className={styles.dlvdOfferSubText}>
                                {cheapestCompetitorQuote.origin.name}
                              </span>
                            </Box>
                          )}
                        </TableCell>
                        {/* DLVD Offer Cell */}
                        <TableCell>
                          <div
                            className={`${styles.priceBold} ${
                              isKochPriceSetter
                                ? styles.dlvdPriceSetterText
                                : ""
                            }`}
                          >
                            ${deliveredPrice}
                          </div>
                        </TableCell>
                        {/* Freight Cell */}
                        <TableCell style={{ paddingLeft: "1px" }}>
                          {/* No Freight Value */}
                          {freight === "--" ? (
                            <span className={styles.destinationFreight}>
                              {freight}
                            </span>
                          ) : (
                            <Button
                              id="freight-button"
                              className={styles.freightCell}
                              sx={{
                                borderRadius: "3px",
                                color: freightColor,
                                backgroundColor: freightBg,
                                "&:hover": {
                                  color: freightHoverColor,
                                  backgroundColor: freightHoverBg,
                                },
                              }}
                              onClick={(event) => {
                                if (cheapestKochQuote?.mode === "RAIL") {
                                  setRailFreightDetailContext({
                                    quote: cheapestKochQuote,
                                    destination: entry.destination,
                                    rowKey: getQuoteRowKey(cheapestKochQuote),
                                  });
                                  setDisplayFreightDetailsPanel(true);
                                }
                                if (cheapestKochQuote?.mode === "TRUCK") {
                                  setDisplayTruckFreightDetailsPanel(true);
                                  setSelectedTruckDetailRecord(
                                    cheapestKochQuote.freight as FreightTruck,
                                  );
                                  setAnchorForTruckDetailsPanel(
                                    event.currentTarget,
                                  );
                                }
                              }}
                            >
                              <span className={styles.destinationFreight}>
                                ${freight}
                              </span>
                              {isQuoted && !isNotified && <QuotedRateIcon />}
                              {isNotified && <QuotedRateNotifiedIcon />}
                            </Button>
                          )}
                        </TableCell>
                        {/* FOB Netback Cell */}
                        <TableCell>
                          <div className={styles.priceBold}>
                            {cheapestKochQuote?.mode.toUpperCase() === "RAIL" &&
                              cheapestKochQuote.freight &&
                              "minCars" in cheapestKochQuote.freight && (
                                <span className={styles.railCarCount}>
                                  {cheapestKochQuote.freight.minCars}+{" "}
                                </span>
                              )}
                            <span className={styles.destinationFOBNetback}>
                              ${!netback ? "--" : netback}
                            </span>
                          </div>
                          {cheapestKochQuote?.freight && (
                            <Box className={styles.fobSubCell}>
                              {cheapestKochQuote?.mode.toUpperCase() ===
                                "TRUCK" && (
                                <TruckIconFO color="#60A5FA" paddingTop={4} />
                              )}
                              {cheapestKochQuote?.mode.toUpperCase() ===
                                "RAIL" && (
                                <RailIconFO color="#F97316" paddingTop={4} />
                              )}
                              <span className={styles.fobSubText}>
                                {cheapestKochQuote?.origin.name} ({netback} -{" "}
                                {alternative || netback})
                              </span>
                            </Box>
                          )}
                        </TableCell>
                        {/* Actions Cell */}
                        <TableCell>
                          <IconButton
                            id="destination-toggle-button"
                            size="small"
                            disableRipple
                            onClick={() => handleToggleClick(entry.destination)}
                          >
                            {isExpanded ? (
                              <Box
                                sx={{
                                  backgroundColor: "#DBEAFE",
                                  borderRadius: "6px",
                                  justifyContent: "center",
                                  display: "flex",
                                  alignItems: "center",
                                  height: 24.5,
                                  width: 24.5,
                                }}
                              >
                                <KeyboardArrowUp sx={{ color: "#1D4ED8" }} />
                              </Box>
                            ) : (
                              <KeyboardArrowDown />
                            )}
                          </IconButton>
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: "#F8FAFC" }}>
                        <TableCell
                          colSpan={6}
                          className={styles.collapseCell}
                          sx={{ paddingRight: 0 }}
                        >
                          <Collapse
                            in={isExpanded}
                            timeout="auto"
                            unmountOnExit
                          >
                            <OriginTableOld
                              quotes={entry.quotes}
                              destination={entry.destination}
                              resetTrigger={refetchMultiLocation}
                            />
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Additional Tables */}
        <div style={{ paddingTop: "50px", flexShrink: 0 }}>
          {/* Destinations Without Product Table */}
          {destinationsWithoutProduct.length > 0 && (
            <div className={styles.destWithoutProductMetaContainer}>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingLeft: 0,
                          paddingRight: 0,
                          borderBottom: "none",
                          background: "rgba(255, 251, 235, 0.50)",
                          width: "100%",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            paddingTop: "12px",
                            paddingBottom: "8px",
                            paddingLeft: "16px",
                            paddingRight: "16px",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <PinWithSlashIcon
                              className={styles.destWithoutProductPinIcon}
                            />
                            <span className={styles.surroundingLocationsHeader}>
                              Locations Without {product}
                            </span>
                            <span className={styles.destWithoutProductCount}>
                              {destinationsWithoutProduct.length}
                            </span>
                          </Box>

                          <IconButton
                            size="small"
                            disableRipple
                            onClick={() =>
                              setShowDestinationsWithoutProduct(
                                !showDestinationsWithoutProduct,
                              )
                            }
                          >
                            {showDestinationsWithoutProduct ? (
                              <Box
                                sx={{
                                  backgroundColor: "#DBEAFE",
                                  borderRadius: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: 24,
                                  width: 24,
                                }}
                              >
                                <KeyboardArrowUp sx={{ color: "#1D4ED8" }} />
                              </Box>
                            ) : (
                              <KeyboardArrowDown />
                            )}
                          </IconButton>
                        </Box>

                        {showDestinationsWithoutProduct && (
                          <div className={styles.destWithoutProductTip}>
                            Do the following locations accept the product? Click{" "}
                            <span className={styles.destWithoutProductTipBold}>
                              Add Product
                            </span>{" "}
                            to view freight.{" "}
                          </div>
                        )}

                        <Collapse
                          in={showDestinationsWithoutProduct}
                          timeout="auto"
                          unmountOnExit
                        >
                          <MissingProductTable
                            destinations={destinationsWithoutProduct}
                          />
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}

          {/* Surrounding Locations Table */}
          {currentFilters.city && (
            <div className={styles.surroundingLocationsMetaContainer}>
              <TableContainer style={{ overflow: "visible" }}>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingLeft: 0,
                          paddingRight: 0,
                          borderBottom: "none",
                          background: "rgba(239, 246, 255, 0.40)",
                          width: "100%",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            paddingTop: "12px",
                            paddingBottom: "8px",
                            paddingLeft: "16px",
                            paddingRight: "16px",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <PinIcon
                              className={styles.surroundingLocationsPinIcon}
                            />
                            <span className={styles.surroundingLocationsHeader}>
                              Locations in Surrounding Area
                            </span>
                            {isLoadingSurroundingQuotes && (
                              <span style={{ marginLeft: 10, padding: "3px" }}>
                                <CircularProgress size={18} />
                              </span>
                            )}
                            {surroundingQuotes.length > 0 && (
                              <span className={styles.destWithoutProductCount}>
                                {
                                  surroundingQuotes.filter(applyTextFilter)
                                    .length
                                }
                              </span>
                            )}
                          </Box>

                          <IconButton
                            size="small"
                            disableRipple
                            disabled={isLoadingSurroundingQuotes}
                            onClick={() => {
                              // collapsing surrounding locations resets map to only show pins for primary destination quotes

                              if (showSurroundingLocations) {
                                setMultiLocationDestinations(
                                  convertQuotesToRoutesOld(destinationQuotes),
                                );
                                if (surroundingQuoteOpen) {
                                  setSelectedLocation(undefined);
                                  setTempPinLocation(undefined);
                                }
                              }
                              if (!showSurroundingLocations) {
                                const quotes = [
                                  ...destinationQuotes,
                                  ...surroundingQuotes,
                                ];
                                const multiLocDataCompAnalysis =
                                  convertQuotesToRoutesOld(quotes);
                                setMultiLocationDestinations(
                                  multiLocDataCompAnalysis,
                                );
                                // clear the open OriginTable so its routes don't persist over surrounding pins
                                if (expandedDestId) {
                                  setSelectedLocation(undefined);
                                  setTempPinLocation(undefined);
                                  setExpandedDestId(undefined);
                                  setDestinationQuoteOpen(false);
                                }
                              }
                              setShowSurroundingLocations(
                                !showSurroundingLocations,
                              );
                              setExpandedDestination(undefined);
                            }}
                          >
                            {showSurroundingLocations ? (
                              <Box
                                sx={{
                                  backgroundColor: "#DBEAFE",
                                  borderRadius: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: 24,
                                  width: 24,
                                }}
                              >
                                <KeyboardArrowUp sx={{ color: "#1D4ED8" }} />
                              </Box>
                            ) : (
                              <KeyboardArrowDown />
                            )}
                          </IconButton>
                        </Box>

                        <Collapse
                          in={showSurroundingLocations}
                          timeout="auto"
                          unmountOnExit
                        >
                          <SurroundingLocationsTableOld
                            surroundingQuotes={surroundingQuotes}
                            filterText={filterText}
                          />
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </div>
      </div>
    </Paper>
  );
};
